module.exports = __webpack_public_path__ + "static/media/black-valkyrie.581264a3.jpg";